/*
 * action types
 */
export const USER_BOOK = 'USER_BOOK'
export const BOOK_INDEX = 'BOOK_INDEX'
export const UNIT_DETAIL = 'UNIT_DETAIL'
export const LINKED_UNIT_DETAIL = 'LINKED_UNIT_DETAIL'
export const SECTION_LIST = 'SECTION_LIST'
export const RESULTS = 'RESULTS'
export const CURRENT_SECTION = 'CURRENT_SECTION'

/*
 * action creators
 */

export function userBook(book) {
  return {
    payload: book,
    type: USER_BOOK,
  }
}
export function bookIndex(book) {
  return {
    payload: book,
    type: BOOK_INDEX,
  }
}
export function unitDetail(unit) {
  return {
    payload: unit,
    type: UNIT_DETAIL,
  }
}
export function linkedUnitDetail(linkedUnit) {
  return {
    payload: linkedUnit,
    type: LINKED_UNIT_DETAIL,
  }
}
export function sectionList(section) {
  return {
    payload: section,
    type: SECTION_LIST,
  }
}
export function currentSection(section) {
  return {
    payload: section,
    type: CURRENT_SECTION,
  }
}
export function results(section) {
  return {
    payload: section,
    type: RESULTS,
  }
}
